<template>
  <div class="row g-3 mt-1">
    <div class="col-12 col-md-5">
      <label class="form-label">Data Inicial:</label>
      <input type="date" class="form-control" v-model="startDate" />
    </div>
    <div class="col-12 col-md-5">
      <label class="form-label">Data Final:</label>
      <input type="date" class="form-control" v-model="endDate" />
    </div>
    <div class="col-12 col-md-2">
      <button
        type="button"
        class="btn btn-success rounded-pill mt-md-4 mt-2 w-100"
        title="Buscar"
        @click="getAdditives"
      >
        <i class="ph-magnifying-glass me-2"></i>
        Buscar
      </button>
    </div>
  </div>
  <div v-if="additives.length > 0" class="table-responsive">
    <hr />
    <table class="table table-sm table-striped text-center">
      <thead>
        <tr>
          <th>Tipo</th>
          <th>Data de Início</th>
          <th>Data de Término</th>
          <th>Situação</th>
          <th>Valor</th>
          <th>Condição</th>
          <th>Valor Pago</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(additive, index) in additives" :key="index">
          <td>{{ additive.tipoAditivo }}</td>
          <td>{{ dateTimeRmToDateBR(additive.dataInicio) }}</td>
          <td>{{ dateTimeRmToDateBR(additive.dataFim) }}</td>
          <td>{{ additive.situacao }}</td>
          <td>{{ formatToCurrencyBr(additive.valor) }}</td>
          <td>{{ additive.condicao }}</td>
          <td>{{ formatToCurrencyBr(additive.valorPago) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <p v-else class="text-center mt-3 mb-0">
    Nenhum aditivo encontrado para este contrato no período especificado
  </p>
</template>

<script>
import { formatToCurrencyBr } from '@/utils/currency'
import { dateNowUs, dateNowUs30ago, dateTimeRmToDateBR } from '@/utils/date'

export default {
  name: 'AdditivesContract',

  props: {
    additives: {
      type: Array,
      required: true,
    },
  },

  emits: ['getAdditives'],

  data() {
    return {
      startDate: dateNowUs30ago(),
      endDate: dateNowUs(),
      formatToCurrencyBr,
      dateTimeRmToDateBR,
    }
  },

  methods: {
    getAdditives() {
      this.$emit('getAdditives', {
        startDate: this.startDate,
        endDate: this.endDate,
      })
    },
  },
}
</script>
